import { css } from '@emotion/css'
import colors from '@v2/styles/colors';
import Clickable from '../clickables/default';
import { imgV2 } from '@v2/styles/utils';

import iconArrowBack from '@img/dashboard/go-back.svg';
import closeButtonWhite from '@img/modal/close-button-white.svg';
import closeButton from '@img/modal/close-button.svg';

const styles = css({
    height: '60px !important',
    width: '100% !important',
    position: 'fixed',
    left: 0,
    top: 49,
    backgroundColor: colors.BLUE,
    borderRadius: '10px 10px 0 0',
    display: 'flex',
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    flexWrap: 'nowrap',
    paddingLeft: 20,
    paddingRight: 20,
    zIndex: 999,

    '.title, .child': {
        color: '#FFFFFF',
        textTransform: 'uppercase',
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: 3,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap',

        img: {
            marginRight: 12,
        }
    },
});

const stylesOOS = css({
    backgroundColor: colors.RED_DARK,

    '.title, .child': {
        color: '#FFFFFF',
        textTransform: 'uppercase',
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: 3,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap',

        img: {
            marginRight: 12,
        }
    },
});

const styleShip = css({
    backgroundColor: colors.WHITE,
    borderBottom: '1px solid #f0f0f0',

    '.title, .child': {
        color: colors.NAVY,
        textTransform: 'uppercase',
        fontSize: 12,
        fontWeight: 800,
        letterSpacing: 3,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'nowrap',

        img: {
            marginRight: 12,
        }
    },
});

export function SurveyHeader({ back, box }: { back: Function, box?: any }) {
    return (
        <div className={`${styles}`}>
            <Clickable className='title' onClick={() => back()}>
                <img src={iconArrowBack} alt={'go back'} /> Back
            </Clickable>
            {box?.child?.name &&
                <span className="child" >
                    <img src={imgV2('quiz/child-icon.svg')} alt="" />
                    {box.child.name}
                </span>
            }
        </div>
    );
}

export function SwapHeader({ back }: { back: Function }) {
    return (
        <div className={`${styles}`}>
            <span className='title'>Replacing item</span>
            <Clickable onClick={() => back()}>
                <img src={closeButtonWhite} tabIndex={0} role="button" alt={'close modal'} />
            </Clickable>
        </div>
    );
}

export function BuilderHeader({ back }: { back: Function }) {
    return (
        <div className={`${styles}`}>
            <span className='title'>Custom Bundle</span>
            <Clickable onClick={() => back()}>
                <img src={closeButtonWhite} tabIndex={0} role="button" alt={'close modal'} />
            </Clickable>
        </div>
    );
}

export function BuyAgainHeader({ back }: { back: Function }) {
    return (
        <div className={`${styles}`}>
            <span className='title'>Select items to buy again</span>
            <Clickable onClick={() => back()}>
                <img src={closeButtonWhite} tabIndex={0} role="button" alt={'close modal'} />
            </Clickable>
        </div>
    );
}

export function OOSHeader({ back }: { back: Function }) {
    return (
        <div className={`${styles} ${stylesOOS}`}>
            <span className='title'>swap out of stock item</span>
            <Clickable onClick={() => back()}>
                <img src={closeButtonWhite} tabIndex={0} role="button" alt={'close modal'} />
            </Clickable>
        </div>
    );
}

export function ShipTogetherHeader({ back, title }: { back: Function, title?: string }) {
    return (
        <div className={`${styles} ${styleShip}`}>
            <span className='title'>{title || 'SHIP TOGETHER'}</span>
            <Clickable onClick={() => back()}>
                <img src={closeButton} tabIndex={0} role="button" alt={'close modal'} />
            </Clickable>
        </div>
    );
}